<div style="text-align: center;">
	<h1 style="color:#7D9AAA; padding-bottom: 25px">Bill Comparison Automation System</h1>
	<img src="assets/images/logos/splash_screen.png" style="max-width: 100%; max-height: 67% !important; height: 67% !important; padding-bottom: 25px; align-content: center;" />
	<img #img class="img-fluid" src="assets/images/logos/logo_transparent_small.png" style="height:145px;" />
</div>
